<template>
	<div class="content-wrapper">
		<div class="content">
			<div class="container-fluid">
				<div style="text-align: center; margin-top: 150px;">
					<a href=" #">
						<img width="250" src="assets/img/AccessDeniedError.png" alt="AccessDenied" />
						<h2 class="main-title fs-28 mb-2">Access Denied</h2>
						<p class="fs-14 font-gray">You are not authorized to access this page</p>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>
